"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.grey.A700,
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  textAlign: 'center'
}));
